"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = loadUnavailableChoicesSuccess;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _transform = _interopRequireDefault(require("lodash/transform"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function loadUnavailableChoicesSuccess(state, _ref) {
  var unavailableOptionChoices = _ref.unavailableOptionChoices,
    deselectUnavailableChoices = _ref.deselectUnavailableChoices;
  return (0, _transform["default"])(state, function (newState, choice, choiceId) {
    /* eslint-disable no-param-reassign */
    if (unavailableOptionChoices[choice.optionId] && unavailableOptionChoices[choice.optionId][choiceId]) {
      newState[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        isAvailable: false,
        isSelected: deselectUnavailableChoices ? false : choice.isSelected
      });
    } else if (!choice.isAvailable) {
      newState[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        isAvailable: true
      });
    }
    /* eslint-enable no-param-reassign */
  }, _objectSpread({}, state));
}
//# sourceMappingURL=loadUnavailableChoicesSuccess.js.map